module.exports = __webpack_public_path__ + "img/trash-red.6a2ed803.svg";